import {GetterTree} from 'vuex'
import ILocale from "@/modules/PanelSettings/ts/ILocale";

export const getters: GetterTree<any, any> = {

    businessRulesActive (state) {

        return !(!state.settings.business_rules_json_query || !state.settings.business_rules_json_filter);

    },

    searchLocales: (state) => (searchTerm: String) => {

        return state.locales.filter( (locale: ILocale) => {

            return locale.country.match(new RegExp('.*'+searchTerm+'.*','gi')) ||
                locale.language.match(new RegExp('.*'+searchTerm+'.*','gi')) ||
                locale.code.match(new RegExp('.*'+searchTerm+'.*','gi'))
        });
    }
}
